<template>
    <v-btn
        text
        class="text-capitalize text-decoration-underline"
        color="black"
        @click="resetFilters"
    >
        {{ $t('sidebar.btnResetFilters') }}
    </v-btn>
</template>

<script>
    export default {
        name: "ButtonText",
        methods: {
            resetFilters() {
                this.$emit('reset-method');
            }
        }
    }
</script>




// WEBPACK FOOTER //
// src/components/filters/ButtonText.vue